import { useRef } from 'react';
import useScrollListener from '../../hooks/useScrollListener';

import HomeHeader from '../../components/home-header/home-header.component';
import Options from '../../components/options/options.component';
import SectionBox from '../../components/section-box/section-box.component';
import ContactFormBox from '../../components/contact-box/contact-box.component';
import Footer from '../../components/footer/footer.component';
import { sectionEcommerce } from '../../data/ecommerce-section-data';

import bgImage from '../../jpeg/pages/home/8.jpg';

import { ServicesContainer } from './services.styles';

const Services = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);
	const contactRef = useRef(null); // Ref for Contact section

	const scrollToContact = () => {
		// Smoothly scroll to the Contact section
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};


	return(
		<ServicesContainer  ref={contentRef}>
			<HomeHeader bgImage={bgImage} whatToDO={scrollToContact} />
			<Options />
			<SectionBox section={sectionEcommerce} />
			<div ref={contactRef}>
				<ContactFormBox whatContactForm={<div class="klaviyo-form-R3vFLg"></div>} />
			</div>
			<Footer />
		</ServicesContainer>
	);
}

export default Services;